import React from 'react';

type JobInfoCardsProps = {
  keyInfo: Array<{
    key: string;
    label: string;
    value: string;
    icon: React.ComponentType<any>;
    bgColor: string;
    iconColor: string;
  }>;
};

export const JobInfoCards = ({ keyInfo }: JobInfoCardsProps) => {
  return (
    <div className='grid grid-cols-1 gap-3 md:grid-cols-2'>
      { keyInfo.map((item) => (
        <div
            key={item.key}
            className='rounded-lg border border-slate-200 bg-white p-3 shadow-sm'
        >
          <div className='flex items-center gap-3'>
            <div
                className={`flex h-9 w-9 items-center justify-center rounded-lg ${item.bgColor}`}
            >
              <item.icon className={`w-5 h-5 ${item.iconColor}`} />
            </div>
            <div className='min-w-0'>
              <div className='text-xs font-semibold text-slate-500'>
                { item.label }
              </div>
              <div
                  className={`${
                    item.key === 'timeline' ? 'text-xs' : 'text-sm'
                  } truncate font-bold text-slate-900`}
              >
                { item.value }
              </div>
            </div>
          </div>
        </div>
      )) }
    </div>
  );
};
